// extracted by mini-css-extract-plugin
export default {"modalOverlay":"uC-z","modalContent":"vC-z","header":"wC-z","close":"xC-z"};